import React, { useEffect } from "react";
import Text from "../../../utils/Custom/text";
import CommonForm from "../../../utils/commonComponent/commonForm";
import { useParams } from "react-router-dom";
import { CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import { toast } from "react-toastify";
import { getPermissions } from "../rbac/hasAccess";

const EditInspectionItems = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const [inputStates, setInputStates] = React.useState({});

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const inputFields = [
    { type: "TextField", label: "Item Name", stateKey: "items" },
    { type: "TextField", label: "Sub Category", stateKey: "subcategory" },
  ];

  const fetchInspectorItemDetails = async () => {
    try {
      const query = `select * from inspectionItems where id = ${params.id}`;
      const [inspectionItems] = await fetchQuery(query);
      setInputStates(inspectionItems);
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  const onSubmit = () => {
    const url =
      BASE_URL + `inspectionItems${params.id !== "0" ? `/${params.id}` : ""}`;
    const request =
      params.id !== "0"
        ? axiosWithToken.patch(url, inputStates)
        : axiosWithToken.post(url, inputStates);

    request
      .then(() => {
        toast.success(
          params.id !== "0"
            ? "Items Updated Successfully!"
            : "Items Created Successfully!"
        );
        setTimeout(window.location.reload(), 500);
      })
      .catch((error) => console.error("Submit error:", error));
  };

  useEffect(() => {
    if (params.id != 0) fetchInspectorItemDetails();
  }, [params]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0
          ? "Create New Inspector Item"
          : `Update Inspector Item ${inputStates?.items}`}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.create || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={
              params.id == 0 ? "Save" : "Update"
            }
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditInspectionItems;
